import React from 'react';
import { getApiBaseUrl } from 'shared/helper/request';
import { recordStart14DayTrialClick } from 'researcher/helpers/gtm';
import { OUTLINE_BUTTON } from '../components/buttonClasses';
var TRIAL_BUTTON_ID = 'start_14day_free_trial_btn_editing';
var ChinaFreeTrialButton = function ChinaFreeTrialButton(_ref) {
  var productName = _ref.productName,
    price = _ref.price,
    children = _ref.children;
  var handleClick = function handleClick() {
    recordStart14DayTrialClick({
      buttonId: TRIAL_BUTTON_ID,
      productName: productName,
      displayedPrice: (price === null || price === void 0 ? void 0 : price.toString()) || ''
    });
    setTimeout(function () {
      window.location.href = "".concat(getApiBaseUrl(), "/c/CurieFreeTrialChina");
    }, 1000);
  };
  return /*#__PURE__*/React.createElement("button", {
    id: TRIAL_BUTTON_ID,
    type: "button",
    "data-cn-trial-btn": "true",
    "data-cn-service-name": productName,
    "data-price": price,
    className: OUTLINE_BUTTON,
    onClick: handleClick
  }, children);
};
export default ChinaFreeTrialButton;